import React, { useEffect, useState } from 'react'

interface ITimeInputProps {
  placeholder?: string
  value?: string | number | undefined
  required?: boolean
  className?: string
  disabled?: boolean
  onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void
  isValid?: boolean
  isInvalid?: boolean
  min?: string
  max?: string
}

export const TimeInput: React.FC<ITimeInputProps> = ({
  placeholder = 'Digite o horário',
  value: initialValue,
  required = false,
  className = '',
  disabled = false,
  onChange,
  isInvalid,
  isValid,
  min = '',
  max = '',
  ...props
}) => {
  const [value, setValue] = useState(initialValue)

  useEffect(() => setValue(initialValue), [initialValue])

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setValue(e.target.value)
    if (onChange) onChange(e)
  }

  return (
    <div className='w-100'>
      <input
        {...props}
        type='time'
        className={`form-control form-control-solid ${className} ${
          isInvalid ? 'is-invalid' : isValid ? 'is-valid' : ''
        }`}
        placeholder={placeholder}
        value={value}
        onChange={handleChange}
        required={required}
        disabled={disabled}
        min={min}
        max={max}
      />
    </div>
  )
}
